@if (pastDueInvoiceService.hasPastDueInvoice()) {
  <div
    id="past-due-banner"
    class="past-due-banner"
    role="alert"
    aria-live="polite"
  >
    You have a past-due invoice.
    <a
      [href]="billingHref()"
      target="_blank"
      rel="noopener"
      (click)="onPayNowClick()"
      >Pay now</a
    >
    or contact our billing team at
    <a href="mailto:billing@risevision.com">billing&#64;risevision.com</a>
    to avoid service suspension.
  </div>
}
